<template>
  <div>
    <div class="row justify-content-end">
      <div class="col-auto"></div>

      <div class="col-auto">
        <button @click="refresh()" class="btn btn-secondary">
          <i class="bi bi-plus-square"></i> Actualiser
        </button>
      </div>

      <div class="col-auto">
        <button @click="$router.push({ name: 'expenses-create' })" class="btn btn-primary">
          <i class="bi bi-plus-square"></i> Créer
        </button>
      </div>
    </div>
    <br>

    <vue-data-table :headers="headers" :data="expenses" :items-per-page="10" :buttons="buttons"
      :summable-columns="summableColumns">

      <template #cell-paid="{ row }">
        <span class="px-2 py-1 rounded "
          :class="row.paid === true ? 'bg-light-success text-success' : 'bg-light-danger text-danger'">
          {{ row.paid === true ? " Payé " : " Impayé " }}
        </span>
      </template>

    </vue-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      headers: [
        { field: 'reference', label: 'Référence Nº', class: '' },
        { field: 'title', label: 'Désignation', class: '' },
        { field: 'employeeFullName', label: 'Employé', class: '' },
        { field: 'date', label: "Date d'expense", class: '' },
        { field: 'amount', label: 'Montant', class: 'fw-bold', isAmount: true },
        { field: 'paymentMethod', label: 'Mode de paiement', class: '' },
        { field: 'paid', label: 'Etat', class: '' },
      ],
      buttons: [
        {
          label: '',
          icon: 'bi bi-check-square-fill',
          class: 'btn btn-success',
          action: (item) => {
            this.togglePaidStatus(item);
          },
        },
        {
          label: 'Supprimer',
          icon: 'bi bi-trash',
          class: 'btn btn-danger',
          action: (item) => {
            this.deleteExpense(item);
          },
          condition: () => this.$userRole === "Admin" // Vérifie si l'utilisateur est Admin
        },
      ],
      summableColumns: [
        { field: 'amount', class: 'fw-bold' },
      ],
    };
  },
  computed: {
    ...mapGetters("expense", {
      expenses: "getExpenses",
    }),
  },
  mounted() {
    this.refresh();
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("expense/getAll");
    },
    async deleteExpense(expense) {

      await this.$store.dispatch("expense/destroy", expense.reference);
    },
    async togglePaidStatus(expense) {
      const updatedExpense = { ...expense, paid: !expense.paid };
      await this.$store.dispatch("expense/togglePaidStatus", updatedExpense);
    },
  },
};
</script>
